import apolloClientFactory from './graphql/apollo-client-factory';
export default (_ref, updateContext, getContext) => {
  var shared = _ref.shared,
    isProduction = _ref.isProduction,
    defaultClient = _ref.apolloClient,
    toggledFeatures = _ref.toggledFeatures;
  var getAbsoluteUrl = shared.getAbsoluteUrl,
    addListener = shared.addListener;
  var currentToken;
  var buildClient = () => {
    var _getContext;
    var token = (_getContext = getContext()) === null || _getContext === void 0 ? void 0 : _getContext.token;
    currentToken = token;
    return apolloClientFactory({
      graphql: getAbsoluteUrl('/graphql'),
      isProduction,
      toggledFeatures,
      token
    });
  };
  var apolloClient = defaultClient || buildClient();
  addListener(() => {
    var _getContext2;
    if (((_getContext2 = getContext()) === null || _getContext2 === void 0 ? void 0 : _getContext2.token) === currentToken) {
      return;
    }
    updateContext({
      apolloClient: buildClient()
    });
  });
  var getApolloClient = () => getContext().apolloClient;
  return {
    apolloClient,
    getApolloClient
  };
};